import { useState, useEffect } from "react";
import Image from "next/image";

export default function Countdown({ targetDate: initialTargetDate, __isMobile = false }) {
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const valueClass = __isMobile ? "text-xl" : "text-xl md:text-3xl";

  useEffect(() => {
    const targetDate = new Date(initialTargetDate || "2025-10-21T00:00:00");

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) return;

      const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
      const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
      const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [initialTargetDate]);

  return (
    <div className="relative overflow-hidden w-full  mx-auto">
      <div className="absolute inset-0 z-0 ">
        <Image
          src="https://images.unsplash.com/photo-1611971122753-c3c7703674e2?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Countdown background"
          fill
          className="object-cover bg-black/60"
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
        <div className="absolute inset-0 " />
      </div>
      <div className="relative z-10 px-4 py-8  flex flex-col bg-black/50 items-center gap-6">
        <div className="grid grid-cols-4 gap-3 text-center w-full  text-white">
          {[
            { label: "Hari", value: timeLeft.days },
            { label: "Jam", value: timeLeft.hours },
            { label: "Menit", value: timeLeft.minutes },
            { label: "Detik", value: timeLeft.seconds },
          ].map((item, idx) => (
            <div
              key={idx}
              className="bg-black/40 rounded text-center p-3 w-full"
            >
              <p className={`${valueClass} font-caudex`}>{item.value}</p>
              <p className="text-[10px] uppercase tracking-wide">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
